var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1929_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 97C75.2858 97 97 75.2858 97 48.5C97 21.7142 75.2858 0 48.5 0C21.7142 0 0 21.7142 0 48.5C0 75.2858 21.7142 97 48.5 97Z",
    fill: "#EE4338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2901 32.7342C63.3436 31.7876 61.8146 31.7876 60.868 32.7342L49 44.5779L37.132 32.7099C36.1854 31.7634 34.6564 31.7634 33.7099 32.7099C32.7634 33.6564 32.7634 35.1854 33.7099 36.132L45.5779 48L33.7099 59.868C32.7634 60.8146 32.7634 62.3436 33.7099 63.2901C34.6564 64.2366 36.1854 64.2366 37.132 63.2901L49 51.4221L60.868 63.2901C61.8146 64.2366 63.3436 64.2366 64.2901 63.2901C65.2366 62.3436 65.2366 60.8146 64.2901 59.868L52.4221 48L64.2901 36.132C65.2124 35.2097 65.2124 33.6564 64.2901 32.7342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1929_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.4085014def8b9853fbe2468b440ee9d9.svg";
export { ForwardRef as ReactComponent };